<!--
 * @Description: 支付网关产品管理
 * @Author: gao shuai
 * @Date: 2020-02-23 12:04:25
 * @LastEditTime: 2020-08-01 14:49:03
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>支付网关</el-breadcrumb-item>
        <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>产品类型：</span>
          <span class="txtbox">
            <el-select style="width:120px;" v-model="typeofproduct" clearable size="small" placeholder="请选择" @change="getlist">
              <el-option v-for="(item,i) in typedrow" :key="'type'+i" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </span>
        </li>
        <li>
          <span class='tit'>一键切换网银通道：</span>
          <span class="txtbox">
            <el-select style="width:120px;" v-model="switchnetsilver" clearable size="small" placeholder="请选择" @change="getlist">
              <el-option v-for="(item,i) in switchnetdrow" :key="'switchnet'+i" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </span>
        </li>
        <li>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="dialoginfo.show=true">添加</el-button>
          </span>
        </li>
      </ul>
    </div>
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column label="排序号" width="80">
          <template slot-scope="scope">
            <div class="inputcotainer">
              <el-input v-model="scope.row.sort" size="mini" @change="productsort(scope.row.id,scope.row.sort)"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="产品类型">
        </el-table-column>
        <el-table-column prop="priceName" label="产品面值">
        </el-table-column>
        <el-table-column prop="galleryName" label="默认通道">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.state" @change="changestate(scope.row.id)" active-color="#4a90e2" inactive-color="#e4eaec">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作" width='200'>
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="editbth(scope.row.id)">编辑</el-button>
            <el-button size="mini" type="danger" @click.prevent="handleClose(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 编辑产品弹框 -->
    <el-dialog :title="dialoginfo.flag?'添加产品':'编辑产品'" :visible.sync="dialoginfo.show" @close="editinit" custom-class="gs_dialog" width="560px">
      <div class="opeartbox">
        <ul class="clearfix">
          <li>
            <span class='tit'>产品名称</span>
            <span class="txtbox" style="width:400px;">
              <el-input size="small" v-model="dialoginfo.name"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>产品标识</span>
            <span class="txtbox" style="width:400px;">
              <el-input size="small" v-model="dialoginfo.mark"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>产品类型</span>
            <span class="txtbox">
              <el-select style="width:400px;" v-model="dialoginfo.typeMark" @change="typechange" size="small" placeholder="请选择">
                <el-option v-for="(item,i) in dialoginfo.typelist" :key="'type'+i" :label="item.markName" :value="item.typeMark"></el-option>
              </el-select>
            </span>
          </li>
          <li>
            <span class='tit'>默认通道</span>
            <span class="txtbox">
              <el-select style="width:400px;" v-model="dialoginfo.galleryId" size="small" placeholder="请选择">
                <el-option v-for="(item,i) in dialoginfo.throughlist" :key="'channels'+i" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </span>
          </li>
          <li v-if="dialoginfo.flag">
            <div style="width: 460px;text-align: center;border-bottom: 1px solid #ccc;height: 31px;line-height: 32px;margin-bottom: 10px;">费率设置</div>
            <span class='tit'>一键设置</span>
            <span class="txtbox" style="width:80px;">
              <el-input size="small" type="number" @input="allratechange" v-model="dialoginfo.onsetbtn"></el-input>
            </span>
          </li>
        </ul>
        <ol class="clearfix" v-if="dialoginfo.flag">
          <li class="clearfix" v-for="(item,i) in dialoginfo.ratelist" :key="'ratelist'+i">
            <span class="tit">{{item.name}}</span>
            <span class="textBox">
              <el-input size="small" type="number" v-model="item.rate"></el-input>
            </span>
          </li>
        </ol>
      </div>
      <p class="tc pdb10">
        <el-button v-if="dialoginfo.flag" size="small" type="primary" @click="addproduct">提交</el-button>
        <el-button v-else size="small" type="primary" @click="proupdate">提交</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      typeofproduct: '', // 产品类型
      typedrow: [
        { text: '普通产品', value: 0 },
        { text: '网银产品', value: 1 }
      ], // 产品类型下拉
      switchnetsilver: '', // 一键切换网银通道
      switchnetdrow: [], // 一键切换网银通道下拉
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      tableData: [],
      dialoginfo: {
        flag: true, // 增加与编辑弹框flag
        show: false, // 弹框的显隐
        typelist: [], // 产品类型下拉
        throughlist: [], // 通道下拉
        id: '',
        galleryId: '',
        mark: '',
        markName: '',
        name: '',
        orders: null,
        reissueRecords: null,
        sort: 0,
        state: true,
        type: '', // 产品类型
        typeMark: '',
        ratelist: [], // 通道列表
        ratelistback: [], // 通道列表备份
        onsetbtn: ''
      }
    };
  },
  methods: {
    // 通道列表
    getlist() {
      this.$api.apay
        .productlist({
          Type: this.typeofproduct === '' ? -1 : this.typeofproduct,
          GalleryId: this.switchnetsilver === '' ? 0 : this.switchnetsilver,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 一键切换网银通道下拉
    netdrow() {
      this.$api.apay
        .netdrow()
        .then((data) => {
          if (data.status === 200) {
            this.switchnetdrow = data.data;
            this.dialoginfo.ratelistback = data.data;
            this.dialoginfo.ratelist = JSON.parse(JSON.stringify(data.data));
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 删除选中行
    handleClose(id) {
      this.$confirm('是否确定删除该产品?')
        .then(() => {
          this.deleteproduct(id);
        })
        .catch(() => {});
    },
    // 删除产品
    deleteproduct(id) {
      this.$api.apay
        .delproduct({ id: id })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('删除成功！');
            if (this.tableData.length === 1) {
              this.pageIndex = this.pageIndex === 1 ? 1 : this.pageIndex - 1;
            }
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 切换列表中的状态
    changestate(id) {
      this.$api.apay
        .stateproduct({ id: id })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('状态切换成功！');
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 编辑按钮
    async editbth(id) {
      this.$api.apay
        .productinfo({ id: id })
        .then((data) => {
          if (data.status === 200) {
            this.dialoginfo.id = data.data.id;
            this.dialoginfo.galleryId = data.data.galleryId;
            this.dialoginfo.mark = data.data.mark;
            this.dialoginfo.name = data.data.name;
            this.dialoginfo.markName = data.data.markName;
            this.dialoginfo.orders = data.data.orders;
            this.dialoginfo.reissueRecords = data.data.reissueRecords;
            this.dialoginfo.sort = data.data.sort;
            this.dialoginfo.state = data.data.state;
            this.dialoginfo.type = data.data.type;
            this.dialoginfo.typeMark = data.data.typeMark;
            this.prothroughdrow(data.data.typeMark);
            this.dialoginfo.flag = false;
            this.dialoginfo.show = true; // 弹框显隐
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 编辑弹框初始化
    editinit() {
      this.dialoginfo.throughlist = []; // 通道下拉
      this.dialoginfo.flag = true;
      this.dialoginfo.id = '';
      this.dialoginfo.galleryId = '';
      this.dialoginfo.mark = '';
      this.dialoginfo.markName = '';
      this.dialoginfo.name = '';
      this.dialoginfo.orders = null;
      this.dialoginfo.reissueRecords = null;
      this.dialoginfo.sort = 0;
      this.dialoginfo.state = true;
      this.dialoginfo.type = ''; // 产品类型
      this.dialoginfo.typeMark = '';
      this.dialoginfo.ratelist = JSON.parse(
        JSON.stringify(this.dialoginfo.ratelistback)
      );
      this.dialoginfo.onsetbtn = '';
    },
    // 产品类型下拉
    protypedrow() {
      this.$api.apay
        .producttype()
        .then((data) => {
          if (data.status === 200) {
            this.dialoginfo.typelist = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 产品通道下拉
    prothroughdrow(mark) {
      this.$api.apay
        .productthrough({ TypeMark: mark })
        .then((data) => {
          if (data.status === 200) {
            this.dialoginfo.throughlist = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 弹框中类型改变时通道下拉请求
    typechange(value) {
      this.dialoginfo.throughlist = [];
      this.dialoginfo.galleryId = '';
      this.dialoginfo.markName = this.dialoginfo.typelist.filter(
        (item) => item.typeMark === value
      )[0].markName;
      if (value === 'ebank') {
        this.dialoginfo.type = 1;
      } else {
        this.dialoginfo.type = 0;
      }
      this.prothroughdrow(value);
    },
    // 产品更新
    proupdate() {
      if (this.dialoginfo.name === '') {
        this.$messageError('请填写产品名称!');
        return;
      } else if (this.dialoginfo.mark === '') {
        this.$messageError('请填写产品标识!');
        return;
      } else if (this.dialoginfo.galleryId === '') {
        this.$messageError('请选择默认通道!');
        return;
      }
      this.$api.apay
        .proupdate({
          id: this.dialoginfo.id,
          galleryId: this.dialoginfo.galleryId,
          mark: this.dialoginfo.mark,
          markName: this.dialoginfo.markName,
          name: this.dialoginfo.name,
          orders: this.dialoginfo.orders,
          reissueRecords: this.dialoginfo.reissueRecords,
          sort: this.dialoginfo.sort,
          state: this.dialoginfo.state,
          type: this.dialoginfo.type,
          typeMark: this.dialoginfo.typeMark
        })
        .then((data) => {
          if (data.status === 200) {
            this.dialoginfo.show = false;
            this.$messageSuccess('更新成功！');
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 添加产品
    addproduct() {
      if (this.dialoginfo.name === '') {
        this.$messageError('请填写产品名称!');
        return;
      } else if (this.dialoginfo.mark === '') {
        this.$messageError('请填写产品标识!');
        return;
      } else if (this.dialoginfo.typeMark === '') {
        this.$messageError('请选择产品类型!');
        return;
      } else if (this.dialoginfo.galleryId === '') {
        this.$messageError('请选择默认通道!');
        return;
      }
      let numflag = false;
      this.dialoginfo.ratelist.forEach((item) => {
        if (parseFloat(item.rate) < 0) {
          numflag = true;
        }
      });
      if (numflag) {
        this.$messageError('费率值不得小于0');
        return;
      }
      this.$api.apay
        .proadd({
          product: {
            galleryId: this.dialoginfo.galleryId,
            mark: this.dialoginfo.mark,
            markName: this.dialoginfo.markName,
            name: this.dialoginfo.name,
            orders: this.dialoginfo.orders,
            reissueRecords: this.dialoginfo.reissueRecords,
            sort: this.dialoginfo.sort,
            state: this.dialoginfo.state,
            type: this.dialoginfo.type,
            typeMark: this.dialoginfo.typeMark
          },
          productGalleries: this.dialoginfo.ratelist.map((item) => {
            return {
              galleryId: item.id,
              rate: parseFloat(item.rate)
            };
          })
        })
        .then((data) => {
          if (data.status === 200) {
            this.dialoginfo.show = false;
            this.$messageSuccess('添加成功！');
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 一键设置
    allratechange() {
      this.dialoginfo.ratelist.forEach((item) => {
        item.rate = this.dialoginfo.onsetbtn;
      });
    },
    // 列表的排序
    productsort(id, sort) {
      if (sort === '') {
        this.$messageError('请输入排序号！');
        return;
      }
      this.$api.apay
        .prosort({ id: id, sort: parseInt(sort) })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('排序成功！');
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    }
  },
  created() {
    this.getlist();
    this.netdrow();
    this.protypedrow();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  background: #fff;
  ul {
    padding: 15px 20px 1px;
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
  ol {
    li {
      float: left;
      margin-bottom: 10px;
      .tit {
        float: left;
        width: 75px;
        text-align: right;
        margin-right: 10px;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .textBox {
        float: left;
        width: 80px;
      }
    }
  }
}
.inputcotainer {
  &::v-deep .el-input__inner {
    text-align: center;
    border: 1px solid transparent;
    background: none;
    &:hover,
    &:focus {
      background: #fff;
      border-color: #eee;
    }
  }
}
</style>
